import {
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  Input,
  OnInit,
  ViewContainerRef,
  OnDestroy,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { FormCheckboxComponent } from '../components/dynamic-form/components/form-checkbox/form-checkbox.component';
import { FormInputComponent } from '../components/dynamic-form/components/form-input/form-input.component';
import { FormSelectComponent } from '../components/dynamic-form/components/form-select/form-select.component';
import {
  FormConfig,
  IFormComponent,
  IFormConfig,
  IFormField,
  IHasImage,
} from '@models/form/form';
import { ICheckboxField } from '@models/form/checkbox';
import { IInputField } from '@models/form/input';
import { ISelectField } from '@models/form/select';
import { FormFileComponent } from '../components/dynamic-form/components/form-file/form-file.component';
import { FormDateRangePickerComponent } from '../components/dynamic-form/components/form-date-range-picker/form-date-range-picker.component';
import { IDateRangeField } from '@app/infrastructure/models/form/daterange';
import { ITextAreaField } from '@app/infrastructure/models/form/textarea';
import { FormTextAreaComponent } from '../components/dynamic-form/components/form-textarea/form-textarea.component';

@Directive({
  selector: '[appDynamicField]',
})
export class DynamicFieldDirective implements OnInit, OnDestroy {
  @Input() currentImageFile: string = '';
  @Input() fieldConfig: IFormField<
    ICheckboxField &
      IInputField &
      ISelectField &
      IDateRangeField &
      ITextAreaField
  >;
  @Input() formConfig: IFormConfig = new FormConfig();
  @Input() group: UntypedFormGroup = new UntypedFormGroup({});

  private component: ComponentRef<
    IFormComponent<
      ICheckboxField &
        IInputField &
        ISelectField &
        IDateRangeField &
        ITextAreaField
    > &
      IHasImage
  >;

  constructor(
    private container: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
  ) {}

  public ngOnInit(): void {
    this.initializeComponentAndFactory();
  }

  public ngOnDestroy(): void {
    this.component.destroy();
  }

  private initializeComponentAndFactory(): void {
    let factory;
    switch (this.fieldConfig.fieldType) {
      case 'password':
        factory =
          this.resolver.resolveComponentFactory<FormInputComponent>(
            FormInputComponent,
          );
        this.component = this.container.createComponent(factory);
        break;
      case 'input':
        factory =
          this.resolver.resolveComponentFactory<FormInputComponent>(
            FormInputComponent,
          );
        this.component = this.container.createComponent(factory);
        break;
      case 'checkbox':
        factory = this.resolver.resolveComponentFactory<FormCheckboxComponent>(
          FormCheckboxComponent,
        );
        this.component = this.container.createComponent(factory);
        break;
      case 'file':
        factory =
          this.resolver.resolveComponentFactory<FormFileComponent>(
            FormFileComponent,
          );
        this.component = this.container.createComponent(factory);
        this.component.instance.currentImageFile = this.currentImageFile;
        break;
      case 'select':
        factory =
          this.resolver.resolveComponentFactory<FormSelectComponent>(
            FormSelectComponent,
          );
        this.component = this.container.createComponent(factory);
        break;
      case 'daterange':
        factory =
          this.resolver.resolveComponentFactory<FormDateRangePickerComponent>(
            FormDateRangePickerComponent,
          );
        this.component = this.container.createComponent(factory);
        break;
      case 'textarea':
        factory = this.resolver.resolveComponentFactory<FormTextAreaComponent>(
          FormTextAreaComponent,
        );
        this.component = this.container.createComponent(factory);
        break;
      default:
        break;
    }
    this.component.instance.config = this.fieldConfig;
    this.component.instance.formConfig = this.formConfig;
    this.component.instance.group = this.group;
  }
}
